// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"EntityManagementForm_submitButton__iDHMI","error":"EntityManagementForm_error__3kdLE"};